module.exports = __webpack_public_path__ + "img/effects_thumb.8ca570b9.jpg";